module.exports = __webpack_public_path__ + "img/creative-arts.abada6c2.svg";